/**
 * How dates, times and numbers are shown in the Basic dashboard: the person's Settings › Language choices, else the
 * company's (Settings › Profile), else DD MMM YYYY, 12-hour, the browser's time zone. Set by the preferences provider.
 */
let display = { date: 'DD MMM YYYY', time: '12', timeZone: undefined, phone: 'national', currency: 'INR', firstDay: 'monday' };

export const setDisplay = (next) => { display = { ...display, ...next }; };
export const getDisplay = () => display;

const parse = (iso) => (iso instanceof Date ? iso : new Date(iso.length === 10 ? `${iso}T00:00:00` : `${iso}${/[zZ]|[+-]\d\d:\d\d$/.test(iso) ? '' : 'Z'}`));

function parts(d, timeZone) {
  const p = Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone, day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false })
    .formatToParts(d).map((x) => [x.type, x.value]));
  const month = new Intl.DateTimeFormat('en-GB', { timeZone, month: '2-digit' }).format(d);
  return { ...p, mm: month };
}

/** A date in the chosen format, e.g. 12 Sep 2025 / 12/09/2025 / 09/12/2025 / 2025-09-12. Date-only values stay as given. */
export function formatDisplayDate(iso, format = display.date) {
  if (!iso) return '—';
  const dateOnly = typeof iso === 'string' && iso.length === 10;
  const p = parts(parse(iso), dateOnly ? undefined : display.timeZone);
  switch (format) {
    case 'DD/MM/YYYY': return `${p.day}/${p.mm}/${p.year}`;
    case 'MM/DD/YYYY': return `${p.mm}/${p.day}/${p.year}`;
    case 'YYYY-MM-DD': return `${p.year}-${p.mm}-${p.day}`;
    default: return `${Number(p.day)} ${p.month} ${p.year}`;
  }
}

/** A time, 12-hour (10:30 am) or 24-hour (10:30). */
export function formatDisplayTime(iso, format = display.time) {
  if (!iso) return '—';
  return parse(iso).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: format !== '24', timeZone: display.timeZone });
}

export const DATE_FORMATS = [
  ['DD MMM YYYY', 'DD MMM YYYY (12 Sep 2025)'],
  ['DD/MM/YYYY', 'DD/MM/YYYY (12/09/2025)'],
  ['MM/DD/YYYY', 'MM/DD/YYYY (09/12/2025)'],
  ['YYYY-MM-DD', 'YYYY-MM-DD (2025-09-12)'],
];
export const TIME_FORMATS = [['12', '12 Hour (10:30 AM)'], ['24', '24 Hour (10:30)']];
export const CURRENCIES = [['INR', '₹ Indian Rupee (INR)'], ['USD', '$ US Dollar (USD)'], ['EUR', '€ Euro (EUR)'], ['GBP', '£ British Pound (GBP)'], ['AED', 'AED UAE Dirham (AED)'], ['SGD', 'S$ Singapore Dollar (SGD)']];
export const PHONE_FORMATS = [['national', '98765 43210 (National)'], ['international', '+91 98765 43210 (International)']];

/** Common time zones first (the full list comes from the server). */
export const POPULAR_ZONES = [
  ['Asia/Kolkata', '(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi'],
  ['Asia/Dubai', '(GMT+04:00) Abu Dhabi, Dubai'],
  ['Asia/Singapore', '(GMT+08:00) Singapore'],
  ['Europe/London', '(GMT+00:00) London'],
  ['America/New_York', '(GMT-05:00) New York'],
  ['America/Los_Angeles', '(GMT-08:00) Los Angeles'],
  ['Australia/Sydney', '(GMT+10:00) Sydney'],
];
